import React, { useState } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

const TripNote = ({ trip, setTrip, onClose }) => {
  const [editing, setEditing] = useState(false);
  const [isSaving, setIsSaving] = useState(false);

  const handleSave = async () => {
    const token = localStorage.getItem("token");
    const body = {
      name: trip.name,
      start_date: trip.start_date,
      end_date: trip.end_date,
      note: trip.note,
    };

    try {
      setIsSaving(true);
      const res = await fetch(`${process.env.REACT_APP_API_URL}/trips/update_trip/${trip.id}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(body),
      });

      if (!res.ok) {
        const error = await res.json();
        alert(`Update failed: ${JSON.stringify(error.detail)}`);
      } else {
        alert("Trip note saved successfully!");
      }
    } catch (err) {
      console.error("Save failed:", err);
      alert("Failed to save trip note.");
    } finally {
      setIsSaving(false);
      setEditing(false);
    }
  };

  return (
    <div>
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-2 mb-2">
        <h3 className="text-xl font-semibold text-primary">Trip Note</h3>
        <div className="space-x-2">
          <button
            className="text-sm text-blue-600 hover:underline"
            onClick={() => setEditing((prev) => !prev)}
          >
            {editing ? "Cancel" : "Edit"}
          </button>
          <button
            className="text-sm text-gray-600 hover:underline"
            onClick={onClose}
          >
            Close
          </button>
        </div>
      </div>

      {editing ? (
        <>
		<div className="w-full min-h-[200px]">
          <ReactQuill
            theme="snow"
            value={trip.note || ""}
            onChange={(content) => setTrip((prev) => ({ ...prev, note: content }))}
          />
		</div>
          <button
            onClick={handleSave}
            className="mt-4 px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
            disabled={isSaving}
          >
            {isSaving ? "Saving..." : "Save Note"}
          </button>
        </>
      ) : (
        <div
          className="prose prose-sm sm:prose max-w-none text-gray-800"
          dangerouslySetInnerHTML={{
            __html: trip?.note || "<p>Write or paste anything here. e.g. how to get there</p>",
          }}
        />
      )}
    </div>
  );
};

export default TripNote;
